import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ContentImage extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ContentImage {
    return new ContentImage(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
